import { render, staticRenderFns } from "./HomePricePlanning.vue?vue&type=template&id=590527a8&scoped=true&"
import script from "./HomePricePlanning.vue?vue&type=script&lang=js&"
export * from "./HomePricePlanning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590527a8",
  null
  
)

export default component.exports